// const BASE_URL = "https://api-for-college-fair.vercel.app/";
const BASE_URL = "https://api.collegefairs.io";
export { BASE_URL };
